<template lang="pug">
.row
  .col-12.mb-3
    p(style='max-width: 750px; margin-top: 10px')
      | {{ $t('integrations.description') }}

    ul#my-tab.nav.nav-tabs(role='tablist' style='margin-top: 20px')
      li.nav-item(role='presentation')
        router-link.nav-link(
          :class='{ active: isTabActive("alltools") }'
          :to='{ name: "account.integrations.alltools" }'
        ) {{ $t('integrations.allTools') }}
      li.nav-item(role='presentation')
        router-link.nav-link(
          :class='{ active: isTabActive("activeintegrations") }'
          :to='{ name: "account.integrations.activeintegrations" }'
        ) {{ $t('integrations.activeIntegrations') }}

  .col-12
    #myTabContent.tab-content.pt-3
      router-view
</template>

<script>
export default {
  name: 'IntegrationsPage',
  created() {
    this.$store.dispatch('page/setTitle', this.$t('nav.admin.integrations'));
    this.$store.dispatch('page/setHead', this.$t('nav.admin.integrations'));
    this.$store.dispatch('page/setClass', 'account integrations');
  },
  methods: {
    isTabActive(type) {
      return this.$route.name.split('.').pop() === type;
    },
  },
};
</script>
